import {UserActions, UserActionTypes} from '../actions/user.actions';
import {User} from '../models/user';
import {ErrorPayload} from '../models/general';

export interface State {
  user: User;
  isGetUserLoading: boolean;
  isGetUserLoaded: boolean;
  getUserError: string | null;
  isPostUserLoading: boolean;
  isPostUserLoaded: boolean;
  postUserError: string | null;
}

export const initialState: State = {
  user: null,
  isGetUserLoading: false,
  isGetUserLoaded: false,
  getUserError: null,
  isPostUserLoading: false,
  isPostUserLoaded: false,
  postUserError: null
};

export function reducer(state = initialState, action: UserActions): State {
  switch (action.type) {

    case UserActionTypes.GetUser: {
      return {
        ...state,
        isGetUserLoading: true,
        isGetUserLoaded: false,
        getUserError: null
      }
    }

    case UserActionTypes.GetUserComplete: {
      const _user: User = action.payload;
      return {
        ...state,
        user: _user,
        isGetUserLoading: false,
        isGetUserLoaded: true
      }
    }

    case UserActionTypes.GetUserError: {
      const errorPayload: ErrorPayload = action.payload;
      return {
        ...state,
        isGetUserLoading: false,
        isGetUserLoaded: true,
        getUserError: errorPayload.errorMessage
      };
    }

    case UserActionTypes.PostUser: {
      return {
        ...state,
        isPostUserLoading: true,
        isPostUserLoaded: false,
        postUserError: null
      }
    }

    case UserActionTypes.PostUserComplete: {
      return {
        ...state,
        isPostUserLoading: false,
        isPostUserLoaded: true
      }
    }

    case UserActionTypes.PostUserError: {
      const errorPayload: ErrorPayload = action.payload;
      return {
        ...state,
        isPostUserLoading: false,
        isPostUserLoaded: true,
        postUserError: errorPayload.errorMessage
      };
    }

    default:
      return state;
  }
}

export const user = (state: State) => state.user;
export const isGetUserLoading = (state: State) => state.isGetUserLoading;
export const isGetUserLoaded = (state: State) => state.isGetUserLoaded;
export const getUserError = (state: State) => state.getUserError;
export const isPostUserLoading = (state: State) => state.isPostUserLoading;
export const isPostUserLoaded = (state: State) => state.isPostUserLoaded;
export const postUserError = (state: State) => state.postUserError;
